module.exports={
	"Form": "LocationEditManifest",
	"Descriptors": {
		"LocationDetails.Name": {
			"Name": "Name",
			"Hash": "EditLocationName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationEdit",
				"Group": "LocationEdit"
			}
		},
		"LocationDetails.Description": {
			"Name": "Description",
			"Hash": "EditLocationDescription",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "TextArea",
				"Section": "LocationEdit",
				"Group": "LocationEdit"
			}
		},
		"LocationDetails.QRCode": {
			"Name": "QR Code",
			"Hash": "EditLocationQRCode",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationEdit",
				"Group": "LocationEdit"
			}
		},
		"LocationDetails.ParentIDLocation": {
			"Name": "Linked To",
			"Hash": "EditLocationParentIDLocation",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "Picker",
				"Section": "LocationEdit",
				"Group": "LocationEdit",
				"Entity": "Location"
			}
		}
	},
	"Sections": [
		{
			"Name": "Location Edit",
			"Hash": "LocationEdit",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Location Edit",
					"Hash": "LocationEdit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
